export default __webpack_public_path__ + "static/media/86.fcb318f3.jpeg";